export class ContentTemplateRoutes
{
	static Home = '/';
	static ContentList = '/content/template/list';
	static ContentNew = '/content/template/new';
	static ContentCopy(id: string)
	{
		return `/content/template/${id}/new`;
	}
	static ContentEdit(id: string)
	{
		return `/content/template/${id}/edit`;
	}
	static ContentView(id: string)
	{
		return `/content/template/${id}/view`;
	}
	static Make(id: string | null)
	{
		let items = ["/content/template"];
		if (id)
			items.push(`/${id}`);
		items.push(`/make`);
		return items.join("");
	}
}